import { atom } from 'recoil';

export const pendingApiKeyState = atom({
  key: 'Develop/pendingApiKeyState',
  default: false,
});

export const apiKeyListState = atom({
  key: 'Develop/apiKeyListState',
  default: null,
});

export const newApiKeyState = atom<{
  _id: string; key: string; name: string; scopes: string[]; expiresAt: string | null; createdAt: string
}>({
  key: 'Develop/newApiKeyState',
  default: null,
});
